import { localStorageAdapter } from "./LocalStorageAdapter";
import { Base64 } from "js-base64";

const storageSize = 20;
const storageName = "recent_livestreamings";
const localStorage = localStorageAdapter(storageName);

export class RecentLivestreamingsStorage {
  static get() {
    try {
      return JSON.parse(localStorage.getItem(storageName)) || [];
    } catch (e) {
      return [];
    }
  }

  static toQueryParam() {
    let localContents = this.get()
    let encodedContents = Base64.encode(JSON.stringify(localContents));

    return `contents=${encodedContents}`;
  }

  static update(newContent) {
    let localContents = this.get().filter(localContent => localContent.id != newContent.id)
                            .slice(0, this.storageSize() - 1);

    localContents.unshift(newContent);
    localStorage.setItem(storageName, JSON.stringify(localContents));
  }

  static storageSize() {
    return storageSize;
  }
}
